import { Pipe, PipeTransform } from "@angular/core";
import { containerNames } from "./container.const";

@Pipe({ name: "sortEquipment" })
export class SortEquipmentPipe implements PipeTransform {
  transform(eq: string[] = [], args?: any): any {
    return containerNames
      .map((container) => (eq.indexOf(container) !== -1 ? container : null))
      .filter((el) => !!el);
  }
}
